import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";

const BASE_URL = import.meta?.env?.VITE_BASE_URL || "https://nissi-india.com";

const SupervisorPaymentDetailsReport = () => {
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(true);

  // ✅ read paymentid from query string
  const paymentid = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get("paymentid"); // ex: 19
  }, []);

  useEffect(() => {
    const load = async () => {
      try {
        if (!paymentid) {
          setReportData(null);
          setLoading(false);
          return;
        }

        setLoading(true);

        // ✅ call backend getById
        const res = await axios.get(
          `${BASE_URL}/api/supervisorReport/getById`,
          { params: { paymentid } }
        );

        const d = res.data?.data;

        if (!d) {
          setReportData(null);
          setLoading(false);
          return;
        }

        // ✅ normalize for your UI
        const normalized = {
          supervisorCode: d.fld_supervisorcode || d.supervisorCode || "",
          supervisorName: d.fld_supervisorname || d.supervisorName || "",
          payments: [
            {
              sno: 1,
              date: d.fld_entrydate
                ? new Date(d.fld_entrydate).toLocaleDateString("en-GB")
                : "",
              entryNo: d.fld_entryno || d.entryno || "",
              amount: Number(d.fld_amount || d.amount || 0),
              // if backend provides words, use it else blank
              amountWords: d.amountInWords || d.fld_amountinwords || "",
              branch: d.fld_branchname || d.branchName || "",
            },
          ],
          totalAmount: Number(d.fld_amount || d.amount || 0),
        };

        setReportData(normalized);

        // ✅ auto print (optional)
        setTimeout(() => window.print(), 300);
      } catch (err) {
        console.error(err);
        setReportData(null);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [paymentid]);

  return (
    <div className="max-w-3xl mx-auto font-sans bg-white text-xs print:p-0 print:max-w-none">
      <div className="border-2 border-black">
        {/* Header */}
        <div className="px-4 py-3 border-b-2 border-black">
          <h1 className="text-xl font-bold text-red-600">Nissi Infotech</h1>
        </div>

        {/* Report Title */}
        <div className="text-center font-semibold py-2 text-sm border-b border-black">
          Supervisor Payment Details Report
        </div>

        {/* Supervisor Info */}
        <div className="px-4 py-2">
          <div className="flex flex-col gap-1 text-sm">
            <span>
              <span className="font-bold">Supervisor Code :</span>{" "}
              {reportData?.supervisorCode || ""}
            </span>
            <span>
              <span className="font-bold">Supervisor Name :</span>{" "}
              {reportData?.supervisorName || ""}
            </span>
          </div>
        </div>

        {/* Table */}
        <div className="px-0">
          <table className="w-full border border-black border-collapse text-xs">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-black px-2 py-1">Sno</th>
                <th className="border border-black px-2 py-1">Date</th>
                <th className="border border-black px-2 py-1">Entry No</th>
                <th className="border border-black px-2 py-1">Amount</th>
                <th className="border border-black px-2 py-1">Amount In Words</th>
                <th className="border border-black px-2 py-1">Branch</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="text-center py-3">
                    Loading...
                  </td>
                </tr>
              ) : !reportData ? (
                <tr>
                  <td colSpan="6" className="text-center py-3">
                    No data found {paymentid ? `(paymentid: ${paymentid})` : "(paymentid missing)"}
                  </td>
                </tr>
              ) : (
                <>
                  {reportData.payments.map((p, idx) => (
                    <tr key={idx}>
                      <td className="border border-black px-2 py-1 text-center">{p.sno}</td>
                      <td className="border border-black px-2 py-1 text-center">{p.date}</td>
                      <td className="border border-black px-2 py-1 text-center">{p.entryNo}</td>
                      <td className="border border-black px-2 py-1 text-right">
                        {Number(p.amount || 0).toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                      <td className="border border-black px-2 py-1">{p.amountWords}</td>
                      <td className="border border-black px-2 py-1 text-center">{p.branch}</td>
                    </tr>
                  ))}

                  {/* Total Row */}
                  <tr>
                    <td colSpan="3" className="border-none"></td>
                    <td className="border-t-2 border-black px-2 py-1 text-right font-bold">
                      {Number(reportData.totalAmount || 0).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </td>
                    <td colSpan="2" className="border-none"></td>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </div>

        {/* Footer */}
        <div className="px-4 py-2 border-t border-gray-300 mt-4">
          <div className="text-xs text-gray-600">
            Report generated by ERP-Software - www.infraconsoft.com owned by www.nissiinfotech.com
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupervisorPaymentDetailsReport;
